import Vue from 'vue';
import Router from 'vue-router';

import SearchPage from '../pages/SearchPage.vue';
import NewsFeed from '../components/NewsFeed.vue';
import SearchResults from '../components/SearchResults.vue';

import TicketsPage from '../pages/TicketsPage.vue';
import SignPage from '../pages/SignPage.vue';
import TermsPage from '../pages/TermsPage.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    component: SearchPage,
    children: [
      {
        path: '/',
        name: 'NewsFeed',
        component: NewsFeed,
      },
      {
        path: '/search-results/:from/:to/:date/:time/:departure/:categories',
        name: 'SearchResults',
        component: SearchResults,
        props: true,
      },
    ],
  },
  {
    path: '/my-tickets',
    name: 'TicketsPage',
    component: TicketsPage,
  },
  {
    path: '/sign',
    name: 'SignPage',
    component: SignPage,
  },
  {
    path: '/terms',
    name: 'TermsPage',
    component: TermsPage,
  }],
});
